import { memo, FC, SVGProps } from "react"

export const CalendarIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M16.25 3.125H3.75C3.40482 3.125 3.125 3.40482 3.125 3.75V16.25C3.125 16.5952 3.40482 16.875 3.75 16.875H16.25C16.5952 16.875 16.875 16.5952 16.875 16.25V3.75C16.875 3.40482 16.5952 3.125 16.25 3.125Z" />
    <path d="M13.751 1.875V4.375" />
    <path d="M6.24902 1.875V4.375" />
    <path d="M3.125 6.875H16.875" />
  </svg>
))
export default CalendarIcon
